import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformYourVision from "./sections/TransformYourVision";
import TheCncwiseEcosystem from "./sections/TheCncwiseEcosystem";
import IndustrialDiagnosticIntelligence from "./sections/IndustrialDiagnosticIntelligence";
import ExpertiseSince1980 from "./sections/ExpertiseSince1980";
import MaintenanceCommandCenter from "./sections/MaintenanceCommandCenter";
import StopOverpayingForRepairs from "./sections/StopOverpayingForRepairs";
import SubscriptionPlans from "./sections/SubscriptionPlans";
import InitiateYourSupport from "./sections/InitiateYourSupport";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import MachineToolBrands from "./sections/MachineToolBrands";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TransformYourVision />
      <TheCncwiseEcosystem />
      <IndustrialDiagnosticIntelligence />
      <MachineToolBrands />
      <ExpertiseSince1980 />
      <MaintenanceCommandCenter />
      <StopOverpayingForRepairs />
      <SubscriptionPlans />
      <InitiateYourSupport />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}